module.exports = __webpack_public_path__ + "img/cyyc4.35dbf9d7.jpg";